import { action, makeObservable, observable } from "mobx";

export type AssetType = "latest" | "image" | "video" | "music" | "reference";
export type FileType = "image" | "video" | "all";
export type ViewMode = "grid" | "shots";

export interface SelectedAsset {
  type: AssetType;
  path: string;
}

export interface AssetsExplorerOptions {
  threadId?: string;
  fileType?: FileType;
  onSelect: (asset: SelectedAsset) => void;
}

export class AssetsExplorerStore {
  @observable isOpen: boolean = false;
  @observable threadId?: string;
  @observable fileType: FileType = "all";
  @observable onSelect?: (asset: SelectedAsset) => void;

  // A signal to stop all playing media in the modal
  @observable stopPlayingSignal: number = 0;

  constructor() {
    makeObservable(this);
  }

  @action open(options: AssetsExplorerOptions) {
    this.threadId = options.threadId;
    this.fileType = options.fileType || "all";
    this.onSelect = options.onSelect;
    this.isOpen = true;
  }

  @action close() {
    this.isOpen = false;
    this.stopPlaying();
  }

  @action stopPlaying() {
    this.stopPlayingSignal = Date.now();
  }
}

export const assetsExplorerStore = new AssetsExplorerStore();
